import React from 'react';
import { Modal, Box, Typography, Button } from '@mui/material';
import LanguageSelect from '../library/files/FilesEmpty/LanguageSelect';

interface FeedbackModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

const FeedbackModal: React.FC<FeedbackModalProps> = ({
  open,
  onClose,
  onSubmit,
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="feedback-modal-title"
      aria-describedby="feedback-modal-description"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
        }}
      >
        <Typography
          id="feedback-modal-title"
          variant="h6"
          component="h2"
          gutterBottom
        >
          Provide Feedback
        </Typography>
        <Typography id="feedback-modal-description" sx={{ mt: 2, mb: 2 }}>
          Thank you for the feedback. To ensure the transcription is correct,
          please select your language below and reprocess:
        </Typography>
        <Box sx={{ mb: 2 }}>
          <LanguageSelect noCollapse />
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
          <Button onClick={onClose} sx={{ mr: 2 }}>
            Cancel
          </Button>
          <Button onClick={onSubmit} variant="contained" color="primary">
            Reprocess
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default FeedbackModal;
